import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { menuItems, COLORS, FONTS } from '../shared/ContentData';

const Navigation = ({ isMobile, activeSection, setActiveSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const desktopMenuStyle = {
    position: 'fixed',
    top: '50%',
    left: '350px',
    transform: 'translateY(-50%)',
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
    zIndex: 10,
  };

  const mobileMenuStyle = {
    position: 'fixed',
    top: '64px',
    left: 0,
    right: 0,
    backgroundColor: `${COLORS.background}CC`,
    padding: '20px',
    transform: isMenuOpen ? 'translateX(0)' : 'translateX(-100%)',
    transition: 'transform 0.3s ease',
    zIndex: 40,
    height: '100vh'
  };

  const linkStyle = {
    fontFamily: FONTS.primary,
    fontSize: isMobile ? '24px' : '30px',
    color: COLORS.text,
    cursor: 'pointer',
    transition: 'opacity 0.3s ease',
    opacity: 0.7,
    padding: isMobile ? '15px 0' : '0'
  };

  const activeLinkStyle = {
    ...linkStyle,
    opacity: 1
  };

  if (isMobile) {
    return (
      <>
        <header style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: '64px',
          backgroundColor: 'transparent',
          display: 'flex',
          alignItems: 'center',
          padding: '0 20px',
          zIndex: 50
        }}>
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            style={{ 
              background: 'none', 
              border: 'none', 
              cursor: 'pointer', 
              color: COLORS.text,
              padding: '8px'
            }}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </header>

        <nav style={mobileMenuStyle}>
          {menuItems.map((item) => (
            <div
              key={item}
              onClick={() => {
                setActiveSection(activeSection === item ? null : item);
                setIsMenuOpen(false);
              }}
              style={activeSection === item ? activeLinkStyle : linkStyle}
            >
              {item.charAt(0).toUpperCase() + item.slice(1)}
            </div>
          ))}
        </nav>
      </>
    );
  }

  return (
    <nav 
      style={desktopMenuStyle} 
      onClick={(e) => e.stopPropagation()}
    >
      {menuItems.map((section) => (
        <div
          key={section}
          onClick={(e) => {
            e.stopPropagation();
            setActiveSection(activeSection === section ? null : section);
          }}
          style={activeSection === section ? activeLinkStyle : linkStyle}
        >
          {section.charAt(0).toUpperCase() + section.slice(1)}
        </div>
      ))}
    </nav>
  );
};

export default Navigation;